import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseEditComponent } from '../../base/base.edit.component';
import { ExportImportService, LookupService } from '../../../services/models';
import { PluginService, AlertService, AuthenticationService } from '../../../services';
import { HttpResponse } from '@angular/common/http';

@Component({
    templateUrl: './products-export.component.html'
})

export class ProductsExportComponent extends BaseEditComponent implements OnInit {
    exportForm: FormGroup;
    imageForm: FormGroup;
    reportUrl: string = 'products-export';
    // reportUrl: string = '';
    reportTitle: string = '';
    reportText: string = '';
    exportedData: any[];
    countries: string[] = ['AU', 'NZ'];
    timer_status: boolean = false;
    reports: any = null;
    record: any = null;
    recordImport: any = null;
    recordUpload: any = null;

    private timer: number;
    @ViewChild('uploadfile') myDivElementRef: ElementRef;

    constructor(
        private route: ActivatedRoute,
        private ExportImportService: ExportImportService,
        private titleService: Title,
        protected pluginService: PluginService,
        private formBuilder: FormBuilder,
        protected alertService: AlertService,
        protected authenticationService: AuthenticationService
    ) {
        super(pluginService);
        // this.reportUrl = this.route.snapshot.paramMap.get('url');
    }

    ngOnInit() {
        this.exportForm = this.formBuilder.group({
            country: [''],
        });

        this.imageForm = this.formBuilder.group({
            url: [''],
            uploaded_filename: ['']
        });

        this.record = {};
        this.recordImport = {};
        this.recordUpload = {};

        this.reports_load(0);

        this.timer = window.setInterval(_ => {
            this.reports_load(1);
        }, 10000);

        if (this.reportUrl == 'products-export') {
            this.reportTitle = 'Export / Import - Products';
            this.reportText = '';
        }

    }

    reports_load(type) {
        if ((this.reportUrl) && ((type == 0) || (type == 1) && this.timer_status)) {
            this.ExportImportService.getAllWithType("?report_type=" + this.reportUrl)
                .subscribe(
                    data => {
                        this.reports = data.data;

                        this.timer_status = false;

                        for (var i = 0; i <= this.reports.length - 1; i++) {
                            if (this.reports[i].status == 'Processing...') {
                                this.timer_status = true;
                                break;

                            }
                        }
                    },
                    error => {
                    });
        }
    }

    generateExport() {
        if (this.reportUrl) {
            this.record.type = this.reportUrl;
            if (this.exportForm && this.exportForm.get('country')) {
                this.record = {
                    country: this.exportForm.get('country').value,
                };

                // Call your export service to trigger the job
                this.ExportImportService.generateExport(this.record).subscribe(
                    (data) => {
                        // Update exportedData with the data received after export
                        this.exportedData = data;
                    },
                    (error) => {
                        console.error('Error generating export:', error);
                    }
                );
            } else {
                console.error('Export form or country control is not properly initialized.');
            }
        }
    }

    checkFile(files: FileList) {

        if (!files || files.length === 0) {
            alert('No file selected');
            return 0;
        }
        let file: File = files[0];

        var sFileName = file.name;
        var sFileExtension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
        var iFileSize = file.size;

        if (this.reportUrl == 'page-import') {
            if (!(sFileExtension === "json")) {
                var err = { 'error': { 'errors': { 'uploaded_filename': ["Please make sure your file is in json format"] } } };
                this.handleError(err, this.imageForm);
                return 0;
            }
            else if (iFileSize > 62914560) {
                var err = { 'error': { 'errors': { 'uploaded_filename': ["Please make sure your file is less than 60 MB."] } } };
                this.handleError(err, this.imageForm);
                return 0;
            }

            return 1;
        }
        else if (!(sFileExtension === "xlsx")) {
            var err = { 'error': { 'errors': { 'uploaded_filename': ["Please make sure your file is in xlsx format"] } } };
            this.handleError(err, this.imageForm);
            return 0;
        }
        else if (iFileSize > 62914560) {
            var err = { 'error': { 'errors': { 'uploaded_filename': ["Please make sure your file is less than 60 MB."] } } };
            this.handleError(err, this.imageForm);
            return 0;
        } else return 1;

    }

    clickUpload() {
        this.selectFile(this.myDivElementRef.nativeElement.files);
    }

    selectFile(files: FileList) {
        if (this.checkFile(files)) {
            this.uploadFile(files);
        }
    }

    clearFile() {
        this.recordImport.url = null;
        this.imageForm.controls['uploaded_filename'].setValue(['']);
        this.recordImport.loading = null;
        this.recordUpload.message = null;
        this.recordUpload.uploaded_filename = null;
        this.recordUpload.uploaded_path_filename = null;
        this.recordImport.sel_countries = [];
    }

    uploadFile(files: FileList) {
        if (files.length == 0) {
            alert('No file selected');
            return

        }
        let file: File = files[0];

        this.recordImport.loading = true;
        this.ExportImportService.uploadFile(file, this.reportUrl)
            .subscribe(
                event => {
                    if (event instanceof HttpResponse) {
                        this.clearFile();
                        this.recordUpload = event.body;
                    }
                },
                (err) => {
                    this.handleError(err, this.imageForm);
                    console.log("Upload Error:", err);
                },
                () => {
                    this.recordImport.loading = null;
                }
            )
    }

    generateImport() {
        if (this.reportUrl) {
            this.recordImport = this.recordUpload;
            this.recordImport.type = this.reportUrl;
            this.ExportImportService.generateImport(this.recordImport)
                .subscribe(
                    data => {
                        //this.clearFile();
                        this.recordImport = data.data;
                        this.reports = data.meta;

                        this.timer_status = false;

                        for (var i = 0; i <= this.reports.length - 1; i++) {
                            if (this.reports[i].status == 'Processing...') {
                                this.timer_status = true;
                                break;
                            }
                        }
                    },
                    error => {
                        this.handleError(error, this.imageForm);
                    });
        }
    }

    deleteReport(value) {
        if (confirm("Are you sure want to delete this record?")) {
            if (value) {
                this.ExportImportService.delete(value)
                    .subscribe(
                        data => {
                            this.reports_load(0);
                        },
                        error => {
                        });
            }
        }

    }

    ngAfterViewChecked() {
        this.titleService.setTitle('Exports | Products');
    }

    ngOnDestroy() {
        clearInterval(this.timer);
        console.log('Timer deleted');
    }

    helpPopup() {
        window.alert(
            `To import succesfully: first make an export, then edit that xlsx, then import the edited file.
            File name has to follow the following format:
            IMP-[date: YYMMDD]-[file name].xlsx
            e.g. IMP-2024-02-08-products-export.xlsx
            For stability reasons, only certain columns in each table can be imported succesfully once they are edited. These importable columns are--
            'Product Name', 'Slug', 'enabled', 'Model Name', 'SKU', 'Price', 'NZ Price', 'salePrice', 'saleExpiryDate', 'Enabled on Consumer', 'Enabled on Commercial'`
        )
    }

}
